<template>
	<div data-tour-scope="orders-list">
		<!--		<v-navigation-drawer fixed v-model="navStateFilter" :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list dense>
				<v-list-item>
					<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search"></v-text-field>
				</v-list-item>
				<v-list-item>
					<v-menu v-model="dataordine" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
						<template v-slot:activator="{ on }">
							<v-text-field hide-details="auto" :value="computedDatejs" v-on="on" dense clearable @click:clear="cleardate" label="Data ordine"> </v-text-field>
						</template>
						<v-date-picker v-model="settings.filters.created_at" @change="dataordine = false" range></v-date-picker>
					</v-menu>
				</v-list-item>

				<v-list-item>
					<v-select hide-details="auto" v-model="settings.filters.platform" :items="platform" :menu-props="{ maxHeight: '400' }" multiple dense label="Platform"></v-select>
				</v-list-item>
				<v-list-item>
					<v-select hide-details="auto" v-model="settings.filters.payments" :items="payments" :menu-props="{ maxHeight: '400' }" multiple dense label="Payment"></v-select>
				</v-list-item>
				<v-list-item>
					<v-select hide-details="auto" v-model="settings.filters.status" :items="status" :menu-props="{ maxHeight: '400' }" multiple dense label="Status"></v-select>
				</v-list-item>
				<v-list-item>
					<v-select hide-details="auto" v-model="settings.filters.color" :items="selectColor" label="Tags" multiple clearable dense prepend-inner-icon="mdi-tag"></v-select>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>-->
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.listOrder') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>
							<v-btn text to="/trash/orders"><v-icon left>mdi-delete-restore</v-icon>Cestino</v-btn>
							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<v-menu bottom :close-on-click="closeOnClick" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="export">
											<v-icon>mdi-arrow-collapse-down</v-icon>
										</v-btn>
									</template>

									<v-list elevation="0">
										<v-list-item data-tour="export-csv" @click="exportAsync('orders', 'csv', { search: searchfield, payments: settings.filters.payments, created_at: settings.filters.created_at, platform: settings.filters.platform, status: settings.filters.status, selected: selectedchecbox })">
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Esporta in CSV</v-list-item-title>
											</v-list-item-content>
										</v-list-item>

										<v-list-item @click="exportAsync('orders', 'excel', { search: searchfield, payments: settings.filters.payments, created_at: settings.filters.created_at, platform: settings.filters.platform, status: settings.filters.status, selected: selectedchecbox })">
											<v-list-item-icon>
												<v-icon>mdi-arrow-collapse-down</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Esporta in Excel</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>

								<!-- <v-divider vertical></v-divider>-->
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->
								<!-- senza Shopify c'e' una sola voce: il "+" apre direttamente il nuovo ordine -->
								<v-btn v-if="!shopify" elevation="0" text data-tour="add" @click="openNew">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
								<v-menu v-else bottom :close-on-click="closeOnClick" elevation-0 offset-x>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text data-tour="add">
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>
									<v-list elevation="0">
										<v-list-item data-tour="add-order" @click="openNew">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi ordine</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="importItemFromShopify" v-if="shopify">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi ordine singolo da shopify</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="importItemsFromShopify" v-if="shopify">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Aggiungi range ordini da shopify</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-list-item @click="modalDownloadReview = true" v-if="shopify">
											<v-list-item-icon>
												<v-icon>mdi-file-document-multiple-outline</v-icon>
											</v-list-item-icon>

											<v-list-item-content>
												<v-list-item-title>Inserisci il range di Ordini per il riepilogo</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="3">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="3">
									<v-menu v-model="dataordine" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
										<template v-slot:activator="{ on }">
											<v-text-field :value="computedDatejs" v-on="on" outlined dense clearable @click:clear="cleardate" label="Data ordine" hide-details> </v-text-field>
										</template>
										<v-date-picker v-model="settings.filters.created_at" @change="dataordine = false" range></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.platform" :items="platform" outlined multiple dense label="Platform" hide-details></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-menu v-model="datapreparazione" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
										<template v-slot:activator="{ on }">
											<v-text-field :value="computedDatePrepjs" v-on="on" outlined dense clearable @click:clear="cleardatePrep" label="Data ordine fornitore" hide-details> </v-text-field>
										</template>
										<v-date-picker v-model="settings.filters.preparation_date" @change="datapreparazione = false" range></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.payments" :items="payments" outlined multiple dense label="Payment" hide-details></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select v-model="settings.filters.status" :items="status" outlined hide-details multiple dense label="Status"></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-if="hasOrderTags"
										v-model="settings.filters.tags"
										:items="orderTags"
										item-text="label"
										item-value="_id"
										:menu-props="{ closeOnContentClick: true, maxHeight: '400' }"
										label="Tags"
										multiple
										clearable
										dense
										prepend-inner-icon="mdi-tag"
										outlined
										hide-details
									>
										<template v-slot:item="{ item }">
											<v-icon class="mr-2" :color="item.color">mdi-tag</v-icon>
											{{ item.label }}
										</template>
										<template v-slot:selection="{ item }">
											<v-chip small class="mr-1" :style="tagChipStyle(item)">{{ item.label }}</v-chip>
										</template>
									</v-select>
									<v-select
										v-else
										v-model="settings.filters.color"
										:items="selectColor"
										:menu-props="{ closeOnContentClick: true, maxHeight: '400' }"
										label="Tags"
										multiple
										clearable
										dense
										prepend-inner-icon="mdi-tag"
										outlined
										hide-details
									></v-select>
								</v-col>
								<!--                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="settings.filters.brand"
                    :menu-props="{ closeOnContentClick: true }"
                    :items="brands"
                    outlined
                    label="Brand"
                    item-value="_id"
                    multiple
                    item-text="trans.name"
                    clearable
                    dense
                    :search-input.sync="search"
                    @change="clearSearchInput"
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    outlined
                    v-model="settings.filters.categories"
                    :menu-props="{ closeOnContentClick: true }"
                    multiple
                    :items="listcategories"
                    label="Categorie"
                    item-value="_id"
                    item-text="string"
                    clearable
                    dense
                    :search-input.sync="search"
                    @change="clearSearchInput"
                    hide-details
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    outlined
                    v-model="settings.filters.suppliers"
                    :menu-props="{ closeOnContentClick: true }"
                    :items="suppliers"
                    label="Fornitore"
                    item-value="_id"
                    multiple
                    item-text="Company"
                    clearable
                    dense
                    :search-input.sync="search"
                    @change="clearSearchInput"
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="settings.filters.color"
                    outlined
                    :menu-props="{ closeOnContentClick: true }"
                    :items="selectColor"
                    label="Tags"
                    multiple
                    clearable
                    prepend-inner-icon="mdi-tag"
                    dense
                    :search-input.sync="search"
                    @change="clearSearchInput"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="settings.filters.images"
                    outlined
                    :menu-props="{ closeOnContentClick: true }"
                    :items="options"
                    label="Immagini presenti"
                    item-value="value"
                    item-text="text"
                    clearable
                    dense
                    :search-input.sync="search"
                    @change="clearSearchInput"
                    hide-details
                  ></v-select>
                </v-col>-->
							</v-row>
						</v-col>
						<v-card v-if="selectedchecbox.length > 0" elevation="0" outlined data-tour="bulk">
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selectedchecbox.length }}
									<span v-if="selectedchecbox.length === 1" style="margin-left: 1rem"> selezionato </span>
									<span v-else style="margin-left: 1rem"> selezionati </span>
								</v-tab>

								<v-tab @click="editItem(null)" v-if="selectedchecbox.length === 1"> modifica </v-tab>
								<v-tab @click="summaryItem(null)" v-if="selectedchecbox.length === 1"> riepilogo </v-tab>
								<v-tab @click="trackingItem(null)" v-if="selectedchecbox.length === 1"> tracking </v-tab>
								<v-tab @click="duplicateItem(null)" v-if="selectedchecbox.length === 1"> Duplica </v-tab>
								<v-tab @click="exportAsync('orders', 'csv', { search: searchfield, payments: settings.filters.payments, created_at: settings.filters.created_at, platform: settings.filters.platform, status: settings.filters.status, selected: selectedchecbox })">
									Download
								</v-tab>
								<v-tab @click="downloadReview(null)"> Scarica Riepilogo </v-tab>
								<v-tab @click="printMultiple(null)"> Stampa Multipla </v-tab>

								<v-tab @click="creaOrdineFornitore(null)" v-if="checkInPreparazione && selectedchecbox.length >= 1">Ordine Fornitore </v-tab>
								<v-tab @click="annullaOrdineFornitore(null)" v-if="checkRollbackInPreparazione && selectedchecbox.length >= 1"> Annulla Ordine Fornitore</v-tab>
								<v-tab @click="confirmDelete(null)" v-if="selectedchecbox.length >= 1">Elimina</v-tab>
							</v-tabs>
						</v-card>

						<v-data-table
							v-model="selectedall"
							must-sort
							data-tour="table"
							:headers="headers"
							:items="getOrders"
							:options.sync="settings.options"
							:server-items-length="total"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							show-select
							:mobile="isMobile"
							@input="toggle"
							:mobile-breakpoint="0"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni ordine diventa una card; il "+" apre indirizzi e prodotti DENTRO la card -->
								<tbody v-if="mobileCards" class="order-cards">
									<tr v-for="item in righeCard(items)" :key="item._id">
										<td :colspan="headers.length + 1" class="px-3 py-1">
											<key-value-card :fields="campiCard(item)" :style="'border-left: 6px solid ' + getStatusColor(item.StatusOrder, item.preparation_date || null) + ' !important;'">
												<template v-slot:title>
													<span class="order-id" v-html="evidenziaSicuro(item.OrderID)"></span>
													<v-btn icon x-small class="ml-1" title="Modifica" @click="editItem(item)">
														<v-icon small>mdi-magnify</v-icon>
													</v-btn>
												</template>
												<template v-slot:actions>
													<div data-tour="row-check">
														<v-checkbox class="mt-0 mr-0 pr-0 pt-0" v-model="selectedchecbox" :value="item._id" color="primary" hide-details></v-checkbox>
													</div>
													<v-btn small icon color="primary" :title="checkpresenza(item._id) ? 'Chiudi' : 'Mostra indirizzi e prodotti'" @click="extension(item._id)">
														<v-icon>{{ checkpresenza(item._id) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
													<v-menu
														:disabled="disabled"
														:absolute="absolute"
														:open-on-hover="openOnHover"
														:close-on-click="closeOnClick"
														:close-on-content-click="closeOnContentClick"
														:offset-x="offsetX"
														:offset-y="offsetY"
													>
														<template v-slot:activator="{ on: menu }">
															<v-btn v-if="hasOrderTags && item.Tag && item.Tag.color" icon small elevation="0" :color="item.Tag.color" :title="item.Tag.label" v-on="menu">
																<v-icon>mdi-tag</v-icon>
															</v-btn>
															<v-btn v-else icon small elevation="0" :color="hasOrderTags ? 'grey' : item.Color || 'grey'" v-on="menu">
																<v-icon>mdi-tag</v-icon>
															</v-btn>
														</template>
														<v-list dense v-if="hasOrderTags">
															<v-list-item v-for="tag in orderTags" :key="tag._id">
																<v-chip small :style="tagChipStyle(tag)" @click="changeStatus(item, tag)">{{ tag.label }}</v-chip>
															</v-list-item>
															<v-list-item>
																<v-chip small outlined @click="changeStatus(item, null)">Nessun tag</v-chip>
															</v-list-item>
														</v-list>
														<v-list dense v-else>
															<v-list-item v-for="color in selectColor" :key="color">
																<v-btn @click="changeStatus(item, color)" elevation="0" icon :color="color"><v-icon>mdi-tag</v-icon></v-btn>
															</v-list-item>
														</v-list>
													</v-menu>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
																<v-icon color="primary">mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-summary" @click="summaryItem(item)">
																<v-list-item-title class="size9">Riepilogo</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-print" @click="openDialogPrint(item)">
																<v-list-item-title class="size9">Stampa</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-receipt" @click="openReceipt(item)">
																<v-list-item-title class="size9">Ricevuta</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="formatPhoneNumber(item.ShippingAddress?.Phone)" data-tour="row-whatsapp" @click="contactWhatsapp(formatPhoneNumber(item.ShippingAddress?.Phone), item.OrderID)">
																<v-list-item-title>Contatta su WhatsApp</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-duplicate" @click="duplicateItem(item)">
																<v-list-item-title class="size9">Duplica</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-tracking" @click="trackingItem(item)">
																<v-list-item-title class="size9">Tracking</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="!item.preparation_date" data-tour="row-supplier" @click="creaOrdineFornitore(item)">
																<v-list-item-title>Crea ordine Fornitore</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="item.preparation_date" data-tour="row-supplier" @click="annullaOrdineFornitore">
																<v-list-item-title>Annulla ordine Fornitore</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="confirmDelete(item)">
																<v-list-item-title>Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<!-- cliente con evidenziazione della ricerca, ma con escape: nome e cognome arrivano dai marketplace -->
													<div v-if="buyerName(item)" class="order-buyer mb-1" v-html="evidenziaSicuro(buyerName(item))"></div>
													<div class="d-flex align-center flex-wrap mb-1 order-card-icons">
														<v-avatar size="26px" tile class="mr-2">
															<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" />
														</v-avatar>
														<v-avatar size="16px" tile class="mr-2" v-if="item.ShippingAddress?.Country">
															<img :src="getImageFlag(item.ShippingAddress)" :alt="item.ShippingAddress.Country" />
														</v-avatar>
														<template v-if="['Store', 'Amazon', 'Ebay'].includes(item.Platform)">
															<v-btn icon small v-if="!item?.feedback" title="Richiesta Feedback" @click="sendfeedback(item)">
																<v-icon>mdi-comment-quote-outline</v-icon>
															</v-btn>
															<v-btn icon small v-else title="Feedback richiesto">
																<v-icon color="#01579B">mdi-comment-quote-outline</v-icon>
															</v-btn>
														</template>
														<v-avatar v-if="item.printed" size="26px" tile class="mr-2" style="cursor: pointer" title="Stampa effettuata" @click="openDialogPrint(item)">
															<img src="@/assets/images/printer.svg" alt="Stampa effettuata" />
														</v-avatar>
														<v-avatar v-if="item.id_packing_list && item.id_packing_list.length > 0" size="26px" tile class="mr-2" style="cursor: pointer" title="Packing List" @click="packingListItem(item)">
															<img
																:src="item.id_packing_list[0].status === 'completed' ? require('@/assets/images/packing_list_completed.svg') : require('@/assets/images/packing_list.svg')"
																alt="Packing List"
															/>
														</v-avatar>
														<v-avatar v-if="_.trim(item.Message) !== ''" size="26px" tile class="mr-2" title="Ordine contiene delle note">
															<img :src="require('@/assets/images/mail.svg')" alt="Ordine contiene delle note" />
														</v-avatar>
														<v-avatar v-if="item.ShippedTime" size="26px" tile class="mr-2" title="Spedito">
															<img :src="require('@/assets/images/box_ship.svg')" alt="Spedito" />
														</v-avatar>
														<v-avatar v-if="item.requestInvoice" size="26px" tile class="mr-2" title="Richiesta fattura">
															<img :src="require('@/assets/images/invoice.svg')" alt="Richiesta fattura" />
														</v-avatar>
														<v-avatar v-if="item.codProcessed" size="30px" tile class="mr-2" title="Contrassegno Incassato">
															<img :src="require('@/assets/images/Cod.svg')" alt="Contrassegno Incassato" />
														</v-avatar>
														<v-avatar v-if="item?.options?.type === 'giftcard'" size="26px" tile class="mr-2" title="Gift Card">
															<img :src="require('@/assets/images/gift-card2.png')" alt="Gift Card" />
														</v-avatar>
														<v-avatar v-if="item?.options?.wallet?.amount > 0" size="26px" tile class="mr-2" title="Ordine pagato con Wallet">
															<img :src="require('@/assets/images/iconpay/wallet.svg')" alt="Wallet" />
														</v-avatar>
													</div>
													<div class="d-flex align-center flex-wrap mb-1">
														<v-chip
															v-if="item.StatusOrder && item.StatusOrder.value"
															small
															label
															class="mr-2 mb-1"
															:color="getStatusColor(item.StatusOrder, item.preparation_date || null)"
															:text-color="isDarkColor(getStatusColor(item.StatusOrder, item.preparation_date || null)) ? 'white' : 'black'"
														>
															{{ item.StatusOrder.value }}
														</v-chip>
														<LateBadge :info="lateMap[item._id]" class="mr-2 mb-1" />
														<v-chip v-if="hasOrderTags && item.Tag && item.Tag.color" small class="mr-2 mb-1" :style="tagChipStyle(item.Tag)">{{ item.Tag.label }}</v-chip>
														<v-chip v-if="item.Buy" small outlined color="success" class="mr-2 mb-1" title="Margine">
															{{ (scorporoiva(item.Total, item.BuyVat) - item.Buy - item.Fee - item.Transaction?.FeeOrCreditAmount).toFixed(2) }}
														</v-chip>
														<v-chip v-if="item.Refund" small outlined color="error" class="mr-2 mb-1" title="Netto dopo il rimborso">
															{{ (item.Total - item.Refund - item.Fee - item.Transaction?.FeeOrCreditAmount).toFixed(2) }}
														</v-chip>
													</div>
												</template>
												<template v-if="checkpresenza(item._id)">
													<template v-if="item.requestInvoice || item.Message || (item.Platform === 'Store' && !(item.buyer && item.buyer._id))">
														<div class="order-section">Info utili</div>
														<div class="order-line">
															<div v-if="item.requestInvoice" class="red--text font-weight-bold">
																<v-icon small color="red" class="mr-1">mdi-file-document-alert</v-icon>
																Richiesta Fattura
															</div>
															<div v-if="item.Message"><strong>Messaggio dal Cliente:</strong> {{ item.Message }}</div>
															<div v-if="item.Platform === 'Store' && !(item.buyer && item.buyer._id)">Ordine in modalità ospite</div>
														</div>
													</template>
													<div class="order-section mt-3">Dati di spedizione</div>
													<div class="order-line">
														<div v-for="riga in righeIndirizzo(item.ShippingAddress, campiSpedizione)" :key="riga.label" class="order-kv">
															<span>{{ riga.label }}</span>
															<span class="d-flex align-center">
																<span class="order-kv-v">{{ riga.value }}</span>
																<v-btn x-small icon class="ml-1" title="Copia" @click="copy(riga.copia)">
																	<v-icon x-small>mdi-content-copy</v-icon>
																</v-btn>
															</span>
														</div>
														<div v-if="!righeIndirizzo(item.ShippingAddress, campiSpedizione).length" class="grey--text">Nessun indirizzo</div>
													</div>
													<template v-if="item.requestInvoice">
														<div class="order-section mt-3">Dati di fatturazione</div>
														<div class="order-line">
															<div v-for="riga in righeIndirizzo(item.InvoiceAddress, campiFatturazione)" :key="riga.label" class="order-kv">
																<span>{{ riga.label }}</span>
																<span class="d-flex align-center">
																	<span class="order-kv-v">{{ riga.value }}</span>
																	<v-btn x-small icon class="ml-1" title="Copia" @click="copy(riga.copia)">
																		<v-icon x-small>mdi-content-copy</v-icon>
																	</v-btn>
																</span>
															</div>
														</div>
													</template>
													<div class="order-section mt-3">Prodotti acquistati</div>
													<div v-for="(prod, index) in item.Items" :key="'p' + index" class="order-line d-flex">
														<v-img :src="getProductImage(prod, item)" max-width="56" max-height="56" width="56" contain class="mr-3 flex-grow-0">
															<template #placeholder>
																<v-img :src="require('@/assets/images/picture.svg')" max-width="56" max-height="56" contain />
															</template>
														</v-img>
														<div class="flex-grow-1" style="min-width: 0">
															<!-- titolo dal marketplace: escape prima dell'evidenziazione -->
															<div class="font-weight-medium" v-html="evidenziaSicuro(prod.Title) || 'Prodotto'"></div>
															<ComboChoices :combo="prod.combo" :currency="item.Currency" class="mb-1" />
															<div class="order-kv">
																<span>SKU</span><span class="order-kv-v" v-html="evidenziaSicuro(prod.SKU) || '-'"></span>
															</div>
															<div class="order-kv">
																<span>ID</span><span class="order-kv-v" v-html="evidenziaSicuro(prod.ItemID) || '-'"></span>
															</div>
															<div class="order-kv">
																<span>Qtà</span><span class="font-weight-bold">{{ prod.QuantityPurchased }}</span>
															</div>
															<div class="order-kv">
																<span>Prezzo</span>
																<span class="font-weight-bold">
																	<span v-if="item.exchange && item.exchangeRate" class="text-caption">({{ (+prod.TransactionPrice * +item.exchangeRate).toFixed(2) }} {{ item.exchange }})</span>
																	{{ prod.TransactionPrice }} {{ item.Currency }}
																</span>
															</div>
														</div>
													</div>
													<div v-if="!(item.Items || []).length" class="grey--text">Nessun prodotto</div>
												</template>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="!righeCard(items).length">
										<td :colspan="headers.length + 1" class="grey--text text-center py-4">Nessun elemento</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr
											v-if="item.StatusOrder && item.StatusOrder._id"
											:style="'background:' + getStatusColor(item.StatusOrder, item.preparation_date ? item.preparation_date : null) + ';'"
											:class="{ 'text-white': isDarkColor(getStatusColor(item.StatusOrder, item.preparation_date || null)) }"
											:key="`${item._id}${_.random(1, 10000)}`"
										>
											<td data-tour="row-check">
												<v-checkbox class="mt-0 mr-0 pr-0" v-model="selectedchecbox" :value="item._id" color="primary" hide-details></v-checkbox>
											</td>
											<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
												<v-menu top eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon dense v-bind="attrs" v-on="on" :color="isDarkColor(getStatusColor(item.StatusOrder, item.preparation_date || null)) ? 'white' : 'primary'" data-tour="row-menu">
															<v-icon :color="isDarkColor(getStatusColor(item.StatusOrder, item.preparation_date || null)) ? 'white' : 'primary'"> mdi-dots-vertical </v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link data-tour="row-edit" @click="editItem(item)">
															<v-list-item-title class="size9">Modifica</v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-summary" @click="summaryItem(item)">
															<v-list-item-title class="size9">Riepilogo</v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-print" @click="openDialogPrint(item)">
															<v-list-item-title class="size9">Stampa</v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-receipt" @click="openReceipt(item)">
															<v-list-item-title class="size9">Ricevuta</v-list-item-title>
														</v-list-item>
														<v-list-item link v-if="formatPhoneNumber(item.ShippingAddress?.Phone)" data-tour="row-whatsapp" @click="contactWhatsapp(formatPhoneNumber(item.ShippingAddress?.Phone), item.OrderID)">
															<v-list-item-title>Contatta su WhatsApp</v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-duplicate" @click="duplicateItem(item)">
															<v-list-item-title class="size9">Duplica</v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-tracking" @click="trackingItem(item)">
															<v-list-item-title class="size9">Tracking</v-list-item-title>
														</v-list-item>
														<v-list-item link v-if="!item.preparation_date" data-tour="row-supplier" @click="creaOrdineFornitore(item)">
															<v-list-item-title>Crea ordine Fornitore</v-list-item-title>
														</v-list-item>
														<v-list-item link v-if="item.preparation_date" data-tour="row-supplier" @click="annullaOrdineFornitore">
															<v-list-item-title>Annulla ordine Fornitore</v-list-item-title>
														</v-list-item>
														<v-list-item link data-tour="row-delete" @click="confirmDelete(item)">
															<v-list-item-title>Elimina</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
											<td>{{ item.created_at | moment('DD/MM/YYYY HH:mm:ss') }}</td>
											<td class="pr-1 mr-1" style="white-space: nowrap">
												<div style="background: #ffffffcf; border-radius: 5px; padding: 3px">
													<v-avatar size="26px" tile>
														<img :src="getImageMarketplace(item.Platform)" :alt="item.Platform" />
													</v-avatar>
													<v-avatar size="16px" tile style="margin-left: 5px" v-if="item.ShippingAddress?.Country">
														<img :src="getImageFlag(item.ShippingAddress)" :alt="item.ShippingAddress" />
													</v-avatar>
													<!--												<v-icon data-alt="Richiesta Feedback">mdi-comment-quote-outline</v-icon>
													<v-icon alt="Richiesta Feedback">mdi-comment-quote-outline</v-icon>-->

													<span v-if="['Store', 'Amazon', 'Ebay'].includes(item.Platform)">
														<v-tooltip top>
															<template v-slot:activator="{ on, attrs }">
																<v-btn icon="$vuetify" variant="plain" v-bind="attrs" v-on="on" v-if="!item?.feedback" @click="sendfeedback(item)" data-alt="Richiesta Feedback">
																	<v-icon alt="Richiesta Feedback">mdi-comment-quote-outline</v-icon>
																</v-btn>
																<v-btn icon="$vuetify" variant="plain" v-bind="attrs" v-on="on" v-else data-alt="Richiesta Feedback">
																	<v-icon alt="Richiesta Feedback" data-alt="Richiesta Feedback" color="#01579B">mdi-comment-quote-outline</v-icon>
																</v-btn>
															</template>
															<span>Richiesta Feedback</span>
														</v-tooltip>
													</span>
												</div>
											</td>
											<td class="pl-0 ml-0" style="white-space: nowrap">
												<div
													:style="
														item.printed || item.id_packing_list.length > 0 || _.trim(item.Message) !== '' || item.ShippedTime || item.codProcessed || item.requestInvoice
															? 'background: #ffffffcf;border-radius: 5px;padding: 3px;'
															: ''
													"
												>
													<!--												<template v-if="item.worker">-->
													<!--													<v-chip color="success" label small style="min-width: 120px">-->
													<!--														<v-icon left small>mdi-account-circle-outline</v-icon>-->
													<!--														{{ item.worker.name }}-->
													<!--													</v-chip>-->
													<!--												</template>-->
													<!--												<template v-else>-->
													<!--													<v-chip color="white" label small @click="openDialogPrint(item)" style="min-width: 20px">-->
													<!--														<v-icon left small color="red">mdi-progress-alert</v-icon>-->
													<!--														Non assegnato-->
													<!--													</v-chip>-->
													<!--												</template>-->
													<!-- Icona stampa -->
													<template v-if="item.printed">
														<v-avatar size="26px" tile class="mr-2" style="cursor: pointer" @click="openDialogPrint(item)">
															<img src="@/assets/images/printer.svg" alt="Stampa effettuata" />
														</v-avatar>
													</template>

													<!-- Icona packing list -->
													<template v-if="item.id_packing_list.length > 0">
														<v-avatar size="26px" tile class="mr-2" style="cursor: pointer" @click="packingListItem(item)">
															<img
																:src="item.id_packing_list[0].status === 'completed' ? require('@/assets/images/packing_list_completed.svg') : require('@/assets/images/packing_list.svg')"
																alt="Packing List"
															/>
														</v-avatar>
													</template>

													<!-- Icona nota / messaggio -->
													<template v-if="_.trim(item.Message) !== ''">
														<v-avatar size="26px" tile class="mr-2">
															<img :src="require('@/assets/images/mail.svg')" alt="Ordine contiene delle note" />
														</v-avatar>
													</template>

													<!-- Icona spedizione -->
													<template v-if="item.ShippedTime">
														<v-avatar size="26px" tile class="mr-2">
															<img :src="require('@/assets/images/box_ship.svg')" alt="Spedito" />
														</v-avatar>
													</template>

													<!-- Icona Invoice -->
													<template v-if="item.requestInvoice">
														<v-avatar size="26px" tile class="mr-2">
															<img :src="require('@/assets/images/invoice.svg')" alt="Richiesta fattura" />
														</v-avatar>
													</template>

													<!-- Icona Invoice -->
													<template v-if="item.codProcessed">
														<v-avatar size="30px" tile class="mr-2">
															<img :src="require('@/assets/images/Cod.svg')" alt="Contrassegno Incassato" />
														</v-avatar>
													</template>

													<template v-if="item?.options?.type === 'giftcard'">
														<v-avatar size="26px" tile class="mr-2">
															<img :src="require('@/assets/images/gift-card2.png')" alt="Gift Card" />
														</v-avatar>
													</template>

													<template v-if="item?.options?.wallet?.amount > 0">
														<v-avatar size="26px" tile class="mr-2" title="Ordine pagato con Wallet">
															<img :src="require('@/assets/images/iconpay/wallet.svg')" alt="Wallet" />
														</v-avatar>
													</template>
												</div>
											</td>
											<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
												<v-btn small icon @click="extension(item._id)" :color="isDarkColor(getStatusColor(item.StatusOrder, item.preparation_date || null)) ? 'white' : ''">
													<v-icon v-if="!checkpresenza(item._id)">mdi-plus</v-icon>
													<v-icon v-else>mdi-minus</v-icon>
												</v-btn>
											</td>
											<td class="order-id-cell">
												<div class="order-id">
													<span v-html="convertSearch(item.OrderID)"></span>
													<v-btn icon x-small class="ml-1" @click="editItem(item)" :color="isDarkColor(getStatusColor(item.StatusOrder, item.preparation_date || null)) ? 'white' : ''">
														<v-icon small>mdi-magnify</v-icon>
													</v-btn>
												</div>
												<div v-if="item?.Coupon?.code"><span class="order-label">Coupon</span> {{ item.Coupon.code }}</div>
												<div v-if="(item.Bundles || []).length"><span class="order-label">Bundle</span> {{ item.Bundles.map(b => b.name).join(', ') }}</div>
											</td>
											<td class="order-cell">
												<div v-if="buyerName(item)" class="order-buyer" v-html="convertSearch(buyerName(item))"></div>
												<div v-if="item?.Checkout?.StatusPayment?.value">
													<span class="order-label">Pagamento</span> {{ item.Checkout.StatusPayment.value }} {{ item.codProcessed ? '(Incassato)' : '' }}
												</div>
												<div v-if="item?.InvoiceAddress?.Vat || item?.InvoiceAddress?.Fiscalcode">
													<template v-if="item.InvoiceAddress.Vat"><span class="order-label">P.IVA</span> {{ item.InvoiceAddress.Vat }}</template>
													<template v-if="item.InvoiceAddress.Vat && item.InvoiceAddress.Fiscalcode"> · </template>
													<template v-if="item.InvoiceAddress.Fiscalcode"><span class="order-label">CF</span> {{ item.InvoiceAddress.Fiscalcode }}</template>
												</div>
												<div v-if="item?.ShippingService?.ShippingService">
													<span class="order-label">Spedizione</span>&nbsp;<span :style="/express|espress|expedit/i.test(item.ShippingService.ShippingService) ? 'color:#d32f2f;font-weight:700;' : ''">{{ item.ShippingService.ShippingService }}</span>
												</div>
												<div v-if="item.OrderStatus"><span class="order-label">Marketplace</span> {{ item.OrderStatus }}</div>
											</td>
											<td>
												<span v-if="item.StatusOrder && item.StatusOrder.value">{{ item.StatusOrder.value }}</span>
												<div><LateBadge :info="lateMap[item._id]" /></div>
											</td>
											<td>{{ item.preparation_date != undefined || item.preparation_date != null ? new Date(item.preparation_date).toLocaleDateString() : '' }}</td>
											<td class="text-right">
												<v-chip v-if="item.Buy" class="ma-2" color="success" outlined x-small>
													{{ (scorporoiva(item.Total, item.BuyVat) - item.Buy - item.Fee - item.Transaction.FeeOrCreditAmount).toFixed(2) }}
												</v-chip>
												<v-chip v-if="item.Refund" class="ma-2" color="error" outlined x-small>
													{{ (item.Total - item.Refund - item.Fee - item.Transaction.FeeOrCreditAmount).toFixed(2) }}
												</v-chip>
												<span v-if="item.exchange && item.exchangeRate" class="grey--text text-caption"> ({{ (+item.Total * +item.exchangeRate).toFixed(2) }} {{ item.exchange }}) </span>
												{{ item.Total }} {{ item.Currency }}
												<span v-if="item.exchange && item.exchangeRate" class="grey--text text-caption"><br />exchange {{ item.exchangeRate }} </span>
											</td>
											<td class="text-right">{{ +item.Refund > 0 ? item.Refund : '' }}</td>

											<td></td>

											<td>
												<v-menu
													:disabled="disabled"
													:absolute="absolute"
													:open-on-hover="openOnHover"
													:close-on-click="closeOnClick"
													:close-on-content-click="closeOnContentClick"
													:offset-x="offsetX"
													:offset-y="offsetY"
												>
													<template v-slot:activator="{ on: menu }">
														<v-tooltip v-if="hasOrderTags && item.Tag && item.Tag.color" top>
															<template v-slot:activator="{ on: tooltip }">
																<v-btn icon small elevation="0" :color="item.Tag.color" v-on="{ ...menu, ...tooltip }">
																	<v-icon>mdi-tag</v-icon>
																</v-btn>
															</template>
															<span>{{ item.Tag.label }}</span>
														</v-tooltip>
														<v-btn v-else icon small elevation="0" :color="hasOrderTags ? 'grey' : item.Color || 'grey'" v-on="menu">
															<v-icon>mdi-tag</v-icon>
														</v-btn>
													</template>
													<v-list dense v-if="hasOrderTags">
														<v-list-item v-for="tag in orderTags" :key="tag._id">
															<v-chip small :style="tagChipStyle(tag)" @click="changeStatus(item, tag)">{{ tag.label }}</v-chip>
														</v-list-item>
														<v-list-item>
															<v-chip small outlined @click="changeStatus(item, null)">Nessun tag</v-chip>
														</v-list-item>
													</v-list>
													<v-list dense v-else>
														<template v-for="color in selectColor">
															<v-list-item>
																<v-btn @click="changeStatus(item, color)" elevation="0" icon :color="color"><v-icon>mdi-tag</v-icon></v-btn>
															</v-list-item>
														</template>
													</v-list>
												</v-menu>
											</td>
										</tr>
										<template v-if="checkpresenza(item._id)">
											<tr>
												<td :colspan="headers.length + 1" class="pa-0">
													<v-sheet class="ma-2 pa-2" color="#f5f5f5" rounded>
														<div v-if="hasOrderTags && item.Tag && item.Tag.color" class="mb-3 d-flex align-center">
															<strong class="mr-2">Tag:</strong>
															<v-chip small :style="tagChipStyle(item.Tag)">{{ item.Tag.label }}</v-chip>
														</div>

														<template v-if="item.requestInvoice || item.Message || (item.Platform === 'Store' && !item.buyer._id)">
															<h4 class="mb-2">💼 Info Utili</h4>
															<!-- 💼 Richiesta Fattura e Messaggio -->
															<div class="mb-4 d-flex flex-wrap white pa-2">
																<div v-if="item.requestInvoice" class="d-flex align-center">
																	<v-icon color="red" class="mr-2">mdi-file-document-alert</v-icon>
																	<span class="font-weight-bold text-danger">Richiesta Fattura</span>
																</div>
																<div v-if="item.Message" class="d-flex align-center ml-2">
																	<v-icon class="mr-2">mdi-note-text</v-icon>
																	<div><strong>Messaggio dal Cliente:</strong> {{ item.Message }}</div>
																</div>
																<div v-if="item.Platform === 'Store' && !item.buyer._id" class="d-flex align-center ml-2">
																	<v-icon class="mr-2">mdi-note-text</v-icon>
																	<div>Ordine in modalità ospite</div>
																</div>
															</div>
															<v-divider class="mb-4"></v-divider>
														</template>

														<!-- 📬 Indirizzo di Spedizione -->
														<div class="mb-3">
															<h4 class="mb-2">📦 Dati di Spedizione</h4>
															<div class="d-flex flex-wrap white pa-2">
																<div v-if="item.ShippingAddress?.Name" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Nome:</strong> {{ item.ShippingAddress.Name }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.Name)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress?.Street1" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Indirizzo:</strong> {{ item.ShippingAddress.Street1 }} {{ item.ShippingAddress.Street2 }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.Street1)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress?.CityName" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Città:</strong> {{ item.ShippingAddress.CityName }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.CityName)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress?.PostalCode" class="mr-6 d-flex align-center">
																	<strong class="mr-2">CAP:</strong> {{ item.ShippingAddress.PostalCode }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.PostalCode)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress?.StateOrProvince" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Provincia:</strong> {{ item.ShippingAddress.StateOrProvince }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.StateOrProvince)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress?.Country" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Nazione:</strong> {{ item.ShippingAddress.Country }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.Country)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
																<div v-if="item.ShippingAddress?.Phone" class="mr-6 d-flex align-center">
																	<strong class="mr-2">Telefono:</strong> {{ item.ShippingAddress.Phone }}
																	<v-btn small icon class="ml-2" @click="copy(item.ShippingAddress.Phone)">
																		<v-icon>mdi-content-copy</v-icon>
																	</v-btn>
																</div>
															</div>
														</div>

														<!-- 🧾 Indirizzo di Fatturazione -->
														<template v-if="item.requestInvoice">
															<v-divider class="mb-4"></v-divider>
															<div class="mb-3">
																<h4 class="mb-2">🧾 Dati di Fatturazione</h4>
																<div class="d-flex flex-wrap white pa-2">
																	<div v-if="item.InvoiceAddress.Company" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Azienda:</strong> {{ item.InvoiceAddress.Company }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Company)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress.Address" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Indirizzo:</strong> {{ item.InvoiceAddress.Address }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Address)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress.City" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Città:</strong> {{ item.InvoiceAddress.City }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.City)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress.Province" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Provincia:</strong> {{ item.InvoiceAddress.Province }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Province)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress.Country" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Nazione:</strong> {{ item.InvoiceAddress.Country }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Country)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress.Cap" class="mr-6 d-flex align-center">
																		<strong class="mr-2">CAP:</strong> {{ item.InvoiceAddress.Cap }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Cap)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress.Vat" class="mr-6 d-flex align-center">
																		<strong class="mr-2">P.IVA:</strong> {{ item.InvoiceAddress.Vat }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Vat)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress.Fiscalcode" class="mr-6 d-flex align-center">
																		<strong class="mr-2">Cod. Fiscale:</strong> {{ item.InvoiceAddress.Fiscalcode }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Fiscalcode)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress.Sdi" class="mr-6 d-flex align-center">
																		<strong class="mr-2">SDI:</strong> {{ item.InvoiceAddress.Sdi }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Sdi)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>

																	<div v-if="item.InvoiceAddress.Pec" class="mr-6 d-flex align-center">
																		<strong class="mr-2">PEC:</strong> {{ item.InvoiceAddress.Pec }}
																		<v-btn small icon class="ml-2" @click="copy(item.InvoiceAddress.Pec)">
																			<v-icon>mdi-content-copy</v-icon>
																		</v-btn>
																	</div>
																</div>
															</div>
														</template>

														<!-- 🛒 Prodotti -->
														<v-divider class="mb-3"></v-divider>
														<div>
															<h4 class="mb-2">🛒 Prodotti acquistati</h4>
															<v-simple-table dense>
																<thead>
																	<tr>
																		<th>Immagine</th>
																		<th>SKU</th>
																		<th>ID</th>
																		<th>Titolo</th>
																		<th>Quantità</th>
																		<th>Prezzo</th>
																	</tr>
																</thead>
																<tbody>
																	<tr v-for="(prod, index) in item.Items" :key="index">
																		<td>
																			<v-img :src="getProductImage(prod, item)" max-width="96" max-height="192" contain class="my-1">
																				<template #placeholder>
																					<v-img :src="require('@/assets/images/picture.svg')" max-width="96" max-height="192" contain />
																				</template>
																			</v-img>
																		</td>
																		<td><span v-html="convertSearch(prod.SKU)"></span></td>
																		<td><span v-html="convertSearch(prod.ItemID)"></span></td>
																		<td>
																			<span v-html="convertSearch(prod.Title)"></span>
																			<ComboChoices :combo="prod.combo" :currency="item.Currency" />
																		</td>
																		<td>{{ prod.QuantityPurchased }}</td>
																		<td>
																			<span v-if="item.exchange && item.exchangeRate" class="grey--text text-caption">
																				({{ (+prod.TransactionPrice * +item.exchangeRate).toFixed(2) }} {{ item.exchange }})
																			</span>
																			{{ prod.TransactionPrice }} {{ item.Currency }}
																		</td>
																	</tr>
																</tbody>
															</v-simple-table>
														</div>
													</v-sheet>
												</td>
											</tr>
										</template>

										<!--										<tr v-for="item in items" :key="item._id + '-details'" v-if="checkpresenza(item._id)">-->
										<!--											<td :colspan="headers.length" class="pa-0">-->
										<!--												<v-sheet class="ma-2 pa-4 elevation-1" color="#f5f5f5" rounded>-->
										<!--													&lt;!&ndash; Richiesta Fattura e Messaggio &ndash;&gt;-->
										<!--													<div class="d-flex flex-wrap align-center mb-2">-->
										<!--														<span v-if="item.requestInvoice" class="mr-5 text-danger font-weight-bold">-->
										<!--															📄 Richiesta Fattura-->
										<!--														</span>-->
										<!--																							<span v-if="item.Message">-->
										<!--															📝 <strong>Messaggio:</strong> {{ item.Message }}-->
										<!--														</span>-->
										<!--													</div>-->

										<!--													&lt;!&ndash; Dati di spedizione &ndash;&gt;-->
										<!--													<div class="d-flex flex-wrap align-center">-->
										<!--														<div class="mr-5">-->
										<!--															<strong>Nome:</strong> {{ item.ShippingAddress.Name }}-->
										<!--															<v-btn small icon @click="copy(item.ShippingAddress.Name)">-->
										<!--																<v-icon>mdi-content-copy</v-icon>-->
										<!--															</v-btn>-->
										<!--														</div>-->
										<!--														<div class="mr-5">-->
										<!--															<strong>Indirizzo:</strong> {{ item.ShippingAddress.Street1 }} {{ item.ShippingAddress.Street2 }}-->
										<!--															<v-btn small icon @click="copy(item.ShippingAddress.Street1)">-->
										<!--																<v-icon>mdi-content-copy</v-icon>-->
										<!--															</v-btn>-->
										<!--														</div>-->
										<!--														<div class="mr-5">-->
										<!--															<strong>Città:</strong> {{ item.ShippingAddress.CityName }} ({{ item.ShippingAddress.PostalCode }})-->
										<!--															<v-btn small icon @click="copy(item.ShippingAddress.CityName)">-->
										<!--																<v-icon>mdi-content-copy</v-icon>-->
										<!--															</v-btn>-->
										<!--														</div>-->
										<!--														<div class="mr-5">-->
										<!--															<strong>Provincia:</strong> {{ item.ShippingAddress.StateOrProvince }}-->
										<!--															<v-btn small icon @click="copy(item.ShippingAddress.StateOrProvince)">-->
										<!--																<v-icon>mdi-content-copy</v-icon>-->
										<!--															</v-btn>-->
										<!--														</div>-->
										<!--														<div class="mr-5">-->
										<!--															<strong>Nazione:</strong> {{ item.ShippingAddress.Country }}-->
										<!--															<v-btn small icon @click="copy(item.ShippingAddress.Country)">-->
										<!--																<v-icon>mdi-content-copy</v-icon>-->
										<!--															</v-btn>-->
										<!--														</div>-->
										<!--														<div>-->
										<!--															<strong>Telefono:</strong> {{ item.ShippingAddress.Phone }}-->
										<!--															<v-btn small icon @click="copy(item.ShippingAddress.Phone)">-->
										<!--																<v-icon>mdi-content-copy</v-icon>-->
										<!--															</v-btn>-->
										<!--														</div>-->
										<!--													</div>-->
										<!--												</v-sheet>-->
										<!--											</td>-->
										<!--										</tr>-->
										<!--										<tr class="active" v-if="checkpresenza(item._id) && (item.Message !== '' || item.requestInvoice)">-->
										<!--											<td></td>-->
										<!--											<td></td>-->
										<!--											<td colspan="1" ><strong class="primary text-white pa-2">{{ item.requestInvoice ? 'RICHIESTA FATTURA' : '' }}</strong></td>-->
										<!--											<td colspan="10">Messaggio dal Cliente: {{ item.Message }}</td>-->
										<!--											<td colspan="4"></td>-->
										<!--										</tr>-->
										<!--										<tr class="active" v-if="checkpresenza(item._id)" v-for="prod in item.Items">-->
										<!--											&lt;!&ndash; v-bind:class="toggleClass(2)"      v-if="item.hide"&ndash;&gt;-->
										<!--											<td></td>-->
										<!--											<td></td>-->
										<!--											<td>-->
										<!--												<span v-html="convertSearch(prod.SKU)"></span>-->
										<!--											</td>-->
										<!--											<td>-->
										<!--												<span v-html="convertSearch(prod.ItemID)"></span>-->
										<!--											</td>-->
										<!--											<td>-->
										<!--												{{ prod.Attribute }}-->
										<!--											</td>-->
										<!--											<td colspan="4">-->
										<!--												<span v-html="convertSearch(prod.Title)"></span>-->
										<!--											</td>-->
										<!--											<td>{{ prod.QuantityPurchased }}</td>-->
										<!--											<td class="text-right">{{ prod.TransactionPrice }}</td>-->
										<!--											<td></td>-->
										<!--											<td colspan="5"></td>-->
										<!--										</tr>-->
										<!--										<tr class="active" v-if="checkpresenza(item._id)">-->
										<!--											<td></td>-->
										<!--											<td></td>-->
										<!--											<td colspan="2">-->
										<!--												{{ item.ShippingAddress.Name }}-->
										<!--												<v-btn v-if="item.ShippingAddress.Name" class="ma-2" small icon @click="copy(item.ShippingAddress.Name)">-->
										<!--													<v-icon>mdi-content-copy</v-icon>-->
										<!--												</v-btn>-->
										<!--											</td>-->
										<!--											<td colspan="2">-->
										<!--												{{ item.ShippingAddress.Street1 }} {{ item.ShippingAddress.Street2 }}-->
										<!--												<v-btn v-if="item.ShippingAddress.Street1" class="ma-2" small icon @click="copy(item.ShippingAddress.Street1)">-->
										<!--													<v-icon>mdi-content-copy</v-icon>-->
										<!--												</v-btn>-->
										<!--											</td>-->
										<!--											<td>-->
										<!--												{{ item.ShippingAddress.CityName }}-->
										<!--												<v-btn v-if="item.ShippingAddress.CityName" class="ma-2" small icon @click="copy(item.ShippingAddress.CityName)">-->
										<!--													<v-icon>mdi-content-copy</v-icon>-->
										<!--												</v-btn>-->
										<!--											</td>-->
										<!--											<td colspan="2">-->
										<!--												{{ item.ShippingAddress.PostalCode }}-->
										<!--												<v-btn v-if="item.ShippingAddress.PostalCode" class="ma-2" small icon @click="copy(item.ShippingAddress.PostalCode)">-->
										<!--													<v-icon>mdi-content-copy</v-icon>-->
										<!--												</v-btn>-->
										<!--											</td>-->
										<!--											<td colspan="2">-->
										<!--												{{ item.ShippingAddress.StateOrProvince }}-->
										<!--												<v-btn v-if="item.ShippingAddress.StateOrProvince" class="ma-2" small icon @click="copy(item.ShippingAddress.StateOrProvince)">-->
										<!--													<v-icon>mdi-content-copy</v-icon>-->
										<!--												</v-btn>-->
										<!--											</td>-->
										<!--											<td colspan="2">-->
										<!--												{{ item.ShippingAddress.Country }}-->
										<!--												<v-btn v-if="item.ShippingAddress.Country" class="ma-2" small icon @click="copy(item.ShippingAddress.Country)">-->
										<!--													<v-icon>mdi-content-copy</v-icon>-->
										<!--												</v-btn>-->
										<!--											</td>-->

										<!--											<td colspan="4">-->
										<!--												{{ item.ShippingAddress.Phone }}-->
										<!--												<v-btn v-if="item.ShippingAddress.Phone" class="ma-2" small icon @click="copy(item.ShippingAddress.Phone)">-->
										<!--													<v-icon>mdi-content-copy</v-icon>-->
										<!--												</v-btn>-->
										<!--											</td>-->
										<!--										</tr>-->
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<ImportShopify v-if="operation === 'ImportShopify'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></ImportShopify>
			<ImportsShopify v-if="operation === 'ImportsShopify'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></ImportsShopify>
		</v-dialog>
		<TourOverlay :tour="tour"></TourOverlay>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>L'ordine sarà spostato nel cestino e potrà essere ripristinato.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="primary" text @click="deleteOrderConfirmed"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogOrderSupplier" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="text-h5">Seleziona una data</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<p>Indica una data entro cui tutti gli articoli presenti negli ordini selezionati saranno consegnati</p>
								<v-date-picker v-model="dateOrderSupplier" full-width locale="it-it" landscape :first-day-of-week="1"></v-date-picker>
							</v-col>
						</v-row>
					</v-container>
					<small>*Campi obbligatori</small>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click="dialogOrderSupplier = false"> Annulla </v-btn>
					<v-btn color="blue darken-1" text @click="inviaOrdineFornitore"> Invia </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modalDownloadReview" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="text-h5">Inserisci il range di Ordini per il riepilogo</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<p>Indica in senso decrescente gli ID degli ordini da includere nel download del riepilogo.</p>
								<p v-if="idStart !== '' && idEnd !== ''">N.B. Sarà scaricato un riepilogo ordini con tutti gli ordini a partire da {{ idStart }} fino a {{ idEnd }} (questi inclusi)</p>
								<p v-if="errorDownloadReview !== ''" class="error--text">{{ errorDownloadReview }}</p>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field hide-details="auto" v-model="idStart" label="Ordine ID più recente" outlined clearable></v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field hide-details="auto" v-model="idEnd" label="Ordine ID meno recente" outlined clearable></v-text-field>
							</v-col>
						</v-row>
					</v-container>
					<small>*Campi obbligatori</small>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-spacer></v-spacer>
					<v-btn
						color="blue darken-1"
						text
						@click="
							modalDownloadReview = false;
							loadingDownload = false;
						"
					>
						Annulla
					</v-btn>
					<v-btn color="blue darken-1" text @click="downloadReviewById" :loading="loadingDownload"> Invia </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogPrint" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="text-h5">Stampa</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-text-field hide-details="auto" label="Corriere" v-model="courier_selected" clearable></v-text-field>
							</v-col>
							<template v-if="getRole !== 2">
								<v-col cols="12" sm="12" md="12">
									<v-autocomplete hide-details="auto" :items="users" label="Utente assegnato" v-model="user_selected" clearable return-object item-text="name" item-value="_id"></v-autocomplete>
								</v-col>
							</template>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click="dialogPrint = false"> Annulla </v-btn>
					<v-btn color="blue darken-1" text @click="printOrder"> Stampa </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogPrintMultiple" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="text-h5">Stampa</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-text-field hide-details="auto" label="Corriere" v-model="courier_selected" clearable></v-text-field>
							</v-col>
							<v-col cols="12" sm="12" md="12">
								<v-autocomplete hide-details="auto" :items="users" label="Utente assegnato" v-model="user_selected" clearable return-object item-text="name" item-value="_id"></v-autocomplete>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" text @click="dialogPrintMultiple = false"> Annulla </v-btn>
					<v-btn color="blue darken-1" text @click="printOrderMultiple"> Stampa </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="modalDownloadReview" persistent max-width="600px">
			<v-card>
				<v-card-title>
					<span class="text-h5">Inserisci il range di Ordini per il riepilogo</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<p>Indica in senso decrescente gli ID degli ordini da includere nel download del riepilogo.</p>
								<p v-if="idStart != '' && idEnd != ''">N.B. Sarà scaricato un riepilogo ordini con tutti gli ordini a partire da {{ idStart }} fino a {{ idEnd }} (questi inclusi)</p>
								<p v-if="errorDownloadReview != ''" class="error--text">{{ errorDownloadReview }}</p>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field hide-details="auto" v-model="idStart" label="Ordine ID più recente" outlined clearable></v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field hide-details="auto" v-model="idEnd" label="Ordine ID meno recente" outlined clearable></v-text-field>
							</v-col>
						</v-row>
					</v-container>
					<small>*Campi obbligatori</small>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="blue darken-1"
						text
						@click="
							modalDownloadReview = false;
							loadingDownload = false;
						"
					>
						Annulla
					</v-btn>
					<v-btn color="blue darken-1" text @click="downloadReviewById" :loading="loadingDownload"> Invia </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { isDarkColor } from '../../Helper';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ComboChoices from '@/components/orders/ComboChoices.vue';
import { safeHtml } from '@/utils/safeHtml';
import { useTour } from '@/components/core/tour/useTour';
import { createOrdersListTourSteps, stopOrdersListTour } from './orders-list-tour';
import { listRouteState } from '@/components/core/list/listRouteState';
import { openWithReturn } from '@/components/core/pageReturn';
import LateBadge from '@/components/orderboard/LateBadge.vue';

const ImportShopify = () => import('@/components/orders/ImportShopify.vue');
const ImportsShopify = () => import('@/components/orders/ImportsShopify.vue');

const LIST_SIZE = [15, 25, 50, 100];

const giorno = d => `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
function ultimoMese() {
	const today = new Date();
	const from = new Date();
	from.setMonth(from.getMonth() - 1);
	return [giorno(from), giorno(today)];
}

export default {
	name: 'Order',
	// pagina, righe, ordinamento, ricerca e filtri nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [
		listRouteState({
			filters: { status: 'array', platform: 'array', created_at: 'array', preparation_date: 'array', payments: 'array', color: 'array', tags: 'array' },
			perPageOptions: LIST_SIZE,
		}),
	],
	setup() {
		return { tour: useTour(createOrdersListTourSteps(), { onStop: stopOrdersListTour }) };
	},
	data() {
		return {
			// ordini fermi oltre il limite del loro status (Board ordini): { [orderId]: { level, statusName, ageMs, limitMs } }
			lateMap: {},
			menu: false,
			loadingDownload: false,
			errorDownloadReview: '',
			modalDownloadReview: false,

			idStart: '',
			idEnd: '',
			componentKey: 0,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					status: [],
					platform: [],
					// di default l'ultimo mese; se l'utente svuota le date l'URL lo ricorda (created_at=)
					created_at: ultimoMese(),
					preparation_date: [],
					payments: [],
					agents: [],
					color: [],
					// tag ordine personalizzati (Profile.order_tags); `color` resta per i profili
					// che non ne hanno configurati e usano ancora i colori predefiniti
					tags: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),

			listSize: LIST_SIZE,
			linkdownload: '',
			searchfield: '',
			selected: [],
			selectedchecbox: [],
			selectedall: [],
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: '', value: '' },
				{ text: 'Data', value: 'created_at' },
				{ text: 'Piattaforma', value: 'Platform' },
				{ text: '', value: 'worker' },
				{ text: '', value: '' },
				{ text: 'N. Ordine', value: 'OrderID' },
				{ text: 'Dettagli', value: 'buyer.name' },
				{ text: 'Status', value: 'Status' },
				{ text: 'Data Ord. Fornitore', value: 'preparation_date' },
				{ text: 'Totale', value: 'Total' },
				{ text: 'Reso', value: 'Refund' },
				{ text: '', value: 'Invoice' },
				{ text: '', value: '', sortable: false },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			isMobile: true,
			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			parseDate: [],
			dataordine: '',
			datapreparazione: '',
			platform: [],
			packagings: [],
			status: [],
			payments: [],
			agents: [],
			choosePlaform: [],
			chooseStatus: [],
			choosePayments: [],
			Totale: 0,
			Fee: 0,
			Refund: 0,
			Gain: 0,
			page: 1,

			//Invoice Fattureincloud
			TypeInvoice: '',
			InvoiceItem: '',
			magento: false,
			shopify: false,
			prestashop: false,
			woocommerce: false,
			fattureincloud: false,
			dialogOrderSupplier: false,
			idsOrderSupplier: [],
			singleOrderSupplier: false,
			dateOrderSupplier: '',
			checkInPreparazione: true,
			checkRollbackInPreparazione: false,
			operation: '',
			dialogPrint: false,
			dialogPrintMultiple: false,
			users: [],
			user_selected: null,
			courier_selected: null,
			order_to_print: null,
			orders_to_print: null,
			status_elaboration: null,
			selectColor: ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'],
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},

	created() {},
	async mounted() {
		this.setDialog(false);
		this.setExistFilter(true);
		this.linkdownload = `${this.getUrl}nocors/orders/download`;
		this.updateEnableAgents(false);
		let promises = [];
		promises.push(this.fetchSetting());

		//promises.push(this.fetchService(['ebay', 'magento', 'shopify', 'fattureInCloud']));
		promises.push(this.fetchServiceactive(['fattureInCloud', 'ebay', 'magento', 'shopify', 'mws', 'aliexpress', 'prestashop', 'woocommerce']));
		if (this.getRole !== 2) {
			promises.push(this.fetchUsers());
		}

		const result = await Promise.all(promises);
		const status = result[1];

		let magento = status.find(el => el.service === 'magento' && el.active === true);
		if (magento) {
			this.magento = magento.active;
			this.platform.push('Magento');
		}
		let shopify = status.find(el => el.service === 'shopify' && el.active === true);
		if (shopify) {
			this.shopify = shopify.active;
			this.platform.push('Shopify');
		}

		let aliexpress = status.find(el => el.service === 'aliexpress' && el.active === true);
		if (aliexpress) {
			this.aliexpress = aliexpress.active;
			this.platform.push('Aliexpress');
		}

		let prestashop = status.find(el => el.service === 'prestashop' && el.active === true);
		if (prestashop) {
			this.prestashop = prestashop.active;
			this.platform.push('Prestashop');
		}

		let woocommerce = status.find(el => el.service === 'woocommerce' && el.active === true);
		if (woocommerce) {
			this.woocommerce = woocommerce.active;
			this.platform.push('Woocommerce');
		}

		let fattureincloud = status.find(el => el.service === 'fattureInCloud' && el.active === true);
		if (fattureincloud) {
			this.fattureincloud = fattureincloud.active;
		}
		let mws = status.find(el => el.service === 'mws' && el.active === true);
		if (mws) {
			this.platform.push('Amazon');
		}

		let ebay = status.find(el => el.service === 'ebay' && el.active === true);
		if (ebay) {
			this.platform.push('Ebay');
		}

		this.platform.push('Store');

		this.fetchStatusOrder().then(result => {
			var array_colors = this.getSetting?.status_order ? this.getSetting.status_order : [];
			_.forEach(result.data, el => {
				let textStatus = _.find(el.trans, { lang: this.getLanguage });
				let color = _.find(array_colors, { _id: el._id });
				this.status.push({
					text: textStatus.value,
					value: el._id,
					color: color ? color.color : '#FFFFFFF',
				});

				if (el._id === '60deb7436fee57191fa71150') {
					this.status_elaboration = {
						_id: el._id,
						value: textStatus.value,
					};
				}
			});
		});

		this.fetchPaymentMethod().then(result => {
			_.forEach(result.data, el => {
				this.payments.push({ text: el.value, value: el._id });
			});
		});

		this.fetchAgentMethod().then(result => {
			_.forEach(result.data, el => {
				this.agents.push({ text: el.info.name + ' ' + el.info.lastname, value: el._id });
			});
		});

		this.fetchPackagings().then(result => {
			_.forEach(result.data, el => {
				this.packagings.push({ text: el.name, value: el });
			});
			//console.log(this.packagings)
		});

		if (this.getRole !== 2) {
			for (let user of this.getUsers) {
				this.users.push({ name: user.name, _id: user._id });
			}
		}

		this.onUpdateOrdersList = () => this.getDataFromApi();
		this.$root.$on('updateOrdersList', this.onUpdateOrdersList);
		// stato della lista (pagina, filtri, ricerca) letto dall'URL in data()
		this.listLoad();
		this.$store
			.dispatch('orderboard/fetchLate')
			.then(map => {
				this.lateMap = map || {};
			})
			.catch(() => {});
	},
	watch: {
		selectedLength(val) {
			if (val > 0) {
				//_.set(this.selectedall,'[0]',1)
				//_.assign(this.selectedall[0],1)
				this.selectedall = [-1];
			}
		},
		selectedchecbox() {
			this.checkInPreparazione = true;
			this.checkRollbackInPreparazione = false;

			if (this.selectedchecbox.length === 1) {
				let el = this.selectedchecbox[0];
				let item = _.find(this.getOrders, i => {
					return i._id === el;
				});
				if (item) {
					if (item.Invoice && item.Invoice.Number) {
						if (item.Invoice.Name === 'Ricevuta') {
							this.TypeInvoice = 'Ricevuta';
						}
						if (item.Invoice.Name === 'Fattura') {
							this.TypeInvoice = 'Fattura';
						}
						this.InvoiceItem = true;
					} else {
						this.InvoiceItem = false;
					}

					if (item.preparation_date) {
						this.checkInPreparazione = false;
						this.checkRollbackInPreparazione = true;
					}
				}
			} else {
				_.forEach(this.selectedchecbox, ord => {
					let item = _.find(this.getOrders, i => {
						return i._id === ord;
					});
					if (item && item.preparation_date) {
						this.checkInPreparazione = false;
						this.checkRollbackInPreparazione = true;
					}
				});
			}
		},
	},
	components: {
		ComboChoices,
		ImportShopify,
		ImportsShopify,
		TourOverlay,
		KeyValueCard,
		LateBadge,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// righe dei blocchi indirizzo della card: stessi campi (e stesso valore copiato) del dettaglio desktop
		campiSpedizione() {
			return [
				{ key: 'Name', label: 'Nome' },
				{ key: 'Street1', label: 'Indirizzo', extra: 'Street2' },
				{ key: 'CityName', label: 'Città' },
				{ key: 'PostalCode', label: 'CAP' },
				{ key: 'StateOrProvince', label: 'Provincia' },
				{ key: 'Country', label: 'Nazione' },
				{ key: 'Phone', label: 'Telefono' },
			];
		},
		campiFatturazione() {
			return [
				{ key: 'Company', label: 'Azienda' },
				{ key: 'Address', label: 'Indirizzo' },
				{ key: 'City', label: 'Città' },
				{ key: 'Province', label: 'Provincia' },
				{ key: 'Country', label: 'Nazione' },
				{ key: 'Cap', label: 'CAP' },
				{ key: 'Vat', label: 'P.IVA' },
				{ key: 'Fiscalcode', label: 'Cod. Fiscale' },
				{ key: 'Sdi', label: 'SDI' },
				{ key: 'Pec', label: 'PEC' },
			];
		},
		selectedLength() {
			return this.selectedchecbox.length;
		},
		// tag ordine configurati in Impostazioni > Ordini. Se il profilo non ne ha,
		// tag della riga e filtro restano quelli storici basati sui colori fissi.
		orderTags() {
			return _.orderBy(this.getSetting?.order_tags || [], ['order'], ['asc']);
		},
		hasOrderTags() {
			return this.orderTags.length > 0;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getOrders: 'orders/getOrders',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'orders/getIndex',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'orders/getSortBy',
			getSortDesc: 'orders/getSortDesc',
			getLanguage: 'profile/getLanguage',
			getUsers: 'users/getUsers',
			getSetting: 'settings/getSetting',
			getRole: 'profile/getRole',
		}),
		/*Totale(){
                console.log(filteredItems)
                /!*if(filteredItems.length>0) {
                    return filteredItems.reduce((total, current) => {
                        return total + parseFloat(current.Total)
                    })

                }*!/
            },*/
		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		filteredItems() {
			let filters = this.getOrders;

			filters = filters.filter(d => {
				//console.log("fine",moment(this.parseDate[1]+" 23:59:59").utc().format());
				if (this.parseDate.length === 1) {
					return (
						d.created_at >
						moment(this.parseDate[0] + ' 00:00:00')
							.utc()
							.format()
					);
				}
				if (this.parseDate.length === 2) {
					return (
						d.created_at >
							moment(this.parseDate[0] + ' 00:00:00')
								.utc()
								.format() &&
						d.created_at <
							moment(this.parseDate[1] + ' 23:59:59')
								.utc()
								.format()
					);
				}
				return d;
			});

			filters = filters.filter(d => {
				if (this.choosePlaform.length > 0) {
					return this.choosePlaform.includes(d.Platform);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.chooseStatus.length > 0) {
					return this.chooseStatus.includes(d.Status);
				}
				return d;
			});
			filters = filters.filter(d => {
				if (this.choosePayments.length > 0) {
					return this.choosePayments.includes(d.Checkout.PaymentMethods);
				}
				return d;
			});

			let sum;
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Total, 0);

				this.Totale = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Refund, 0);

				this.Refund = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				let total = 0;
				let refund = 0;
				filters.forEach(value => {
					if (value.Buy) {
						total += this.scorporoiva(value.Total, value.BuyVat) - value.Buy - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
					if (value.Refund) {
						refund += value.Total - value.Refund - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
				});
				this.Gain = parseFloat(total + refund, 2).toFixed(2);
			}
			return filters;
		},
		computedDatejs() {
			let arrayDate = [];
			if (this.settings.filters.created_at.length > 0) {
				this.settings.filters.created_at.forEach(value => {
					// console.log(value)
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
		computedDatePrepjs() {
			let arrayDate = [];
			if (this.settings.filters.preparation_date.length > 0) {
				this.settings.filters.preparation_date.forEach(value => {
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setOrders: 'orders/setOrders',
			setOrder: 'orders/setOrder',
			setItem: 'returnstore/setItem',
			setIndex: 'orders/setIndex',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
			setSnackbarApp: 'settings/setSnackbar',
			setPackingList: 'packingLists/setPackingList',
		}),
		...mapActions({
			fetchOrders: 'orders/asyncFetchData',
			fetchReports: 'orders/asyncFetchReportData',
			destroyData: 'orders/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			createSupplierOrders: 'orders/createSupplierOrders',
			fetchStatusOrder: 'statusorders/fetchLists',
			fetchPaymentMethod: 'paymentmethods/fetchLists',
			fetchAgentMethod: 'agents/fetchLists',
			updateEnableAgents: 'orders/updateEnableAgents',
			getOrdersReview: 'orders/getOrdersReview',
			getOrdersDetail: 'orders/edit',
			fetchPackagings: 'packagings/getListings',
			fetchUsers: 'users/asyncFetchUsers',
			fetchServiceactive: 'services/getServiceFetchActive',
		}),
		buyerName(item) {
			return [item?.buyer?.name, item?.buyer?.lastname].filter(Boolean).join(' ').trim();
		},
		safeHtml,
		// vista card: stesse righe della tabella desktop (che salta gli ordini senza stato)
		righeCard(items) {
			return (items || []).filter(item => item.StatusOrder && item.StatusOrder._id);
		},
		// come convertSearch ma con escape del testo e del termine cercato: nomi cliente e titoli prodotto arrivano dai marketplace
		evidenziaSicuro(value) {
			if (value === undefined || value === null || value === '') return '';
			const testo = safeHtml(value);
			const cerca = this.settings?.search ? safeHtml(this.settings.search) : '';
			if (!cerca) return testo;
			const re = new RegExp(cerca.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
			return testo.replace(re, match => `<mark>${match}</mark>`);
		},
		// stessi dati delle colonne della tabella desktop; i campi opzionali vuoti non vengono mostrati
		campiCard(item) {
			const totale = [
				item.exchange && item.exchangeRate ? `(${(+item.Total * +item.exchangeRate).toFixed(2)} ${item.exchange})` : '',
				`${item.Total} ${item.Currency || ''}`.trim(),
				item.exchange && item.exchangeRate ? `exchange ${item.exchangeRate}` : '',
			]
				.filter(Boolean)
				.join(' ');
			const documento = [item?.InvoiceAddress?.Vat ? `P.IVA ${item.InvoiceAddress.Vat}` : '', item?.InvoiceAddress?.Fiscalcode ? `CF ${item.InvoiceAddress.Fiscalcode}` : ''].filter(Boolean).join(' · ');
			const spedizione = item?.ShippingService?.ShippingService || '';
			const campi = [
				{ label: 'Data', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') : '', fisso: true },
				{ label: 'Coupon', value: item?.Coupon?.code || '' },
				{ label: 'Pagamento', value: item?.Checkout?.StatusPayment?.value ? `${item.Checkout.StatusPayment.value}${item.codProcessed ? ' (Incassato)' : ''}` : '' },
				{ label: 'Fiscale', value: documento },
				// le spedizioni express sono evidenziate come su desktop
				{ label: 'Spedizione', value: spedizione, strong: /express|espress|expedit/i.test(spedizione) },
				{ label: 'Marketplace', value: item.OrderStatus || '' },
				{ label: 'Preparazione', value: item.preparation_date ? new Date(item.preparation_date).toLocaleDateString() : '' },
				{ label: 'Totale', value: totale, strong: true, fisso: true },
				{ label: 'Rimborso', value: +item.Refund > 0 ? item.Refund : '', strong: true },
			];
			return campi.filter(c => c.fisso || (c.value !== '' && c.value !== undefined && c.value !== null)).map(({ label, value, strong }) => ({ label, value, strong }));
		},
		// righe non vuote di un indirizzo; si copia lo stesso valore del pulsante desktop
		righeIndirizzo(indirizzo, campi) {
			if (!indirizzo) return [];
			return campi
				.filter(c => indirizzo[c.key])
				.map(c => ({
					label: c.label,
					value: c.extra && indirizzo[c.extra] ? `${indirizzo[c.key]} ${indirizzo[c.extra]}` : indirizzo[c.key],
					copia: indirizzo[c.key],
				}));
		},
		convertSearch(match) {
			let result = match;

			if (this.settings?.search && result) {
				var re = new RegExp(this.settings.search, 'gi');
				result = match.replace(re, `<mark>${this.settings.search}</mark>`);
			}
			return result;
		},

		convertDataForRange() {
			let stringaData = '';
			const listDate = [];
			const replace = JSON.parse(JSON.stringify(this.settings.filters.created_at));
			if (replace.length > 0) {
				for (let d of replace) {
					const datareplace = new Date(e);
					listDate.push(`${datareplace.getDate()}/${datareplace.getMonth()}/${datareplace.getFullYear()}`);
				}
			}
			if (listDate.length > 0) {
				return listDate.join(' ~ ');
			} else {
				return '';
			}
		},

		async propSetMessages(text) {
			if (text != 'refresh') {
				this.snackbar.color = 'success';
				this.snackbar.text = text;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
			}
			await this.getDataFromApi();
			this.$forceUpdate();
			this.selectedchecbox = [];
			this.operation = '';
		},
		async creaOrdineFornitore(item) {
			this.dialogOrderSupplier = true;
			if (item) {
				this.singleOrderSupplier = true;
				this.idsOrderSupplier = [item._id];
			} else {
				this.singleOrderSupplier = false;
				this.idsOrderSupplier = [];
			}
		},
		async inviaOrdineFornitore() {
			this.dialogOrderSupplier = false;
			this.preload = true;
			this.setPreload(true);
			let orders_id = this.singleOrderSupplier ? this.idsOrderSupplier : this.selectedchecbox;
			let payload = { order_date: this.dateOrderSupplier, order_ids: orders_id };
			let response = await this.createSupplierOrders(payload);

			this.idsOrderSupplier = [];
			this.singleOrderSupplier = false;

			if (response.result === true && response.all_transformed) {
				await this.fetchOrders(this.settings);
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con  successo';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
				this.setPreload(false);
			} else if (response.result === true && !response.all_transformed) {
				this.snackbar.color = 'success';
				this.snackbar.text = 'Operazione effettuata con successo, ma alcuni prodotti non hanno un fornitore associato';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 5000;
				this.preload = false;
				this.setPreload(false);
			} else {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore durante invio in preparazione: ' + response.message;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 10000;
				this.preload = false;
				this.setPreload(false);
			}
		},
		createItem() {
			this.$router.push('/orders/new');
		},
		changePackaging(pack, item) {
			let url = 'orders/updatepackaging';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, Packaging: pack.value }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					item.Packaging = pack.value;
				})
				.catch(err => {
					if (err.response) {
						const apiMessage = err.response?.data?.message;
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = apiMessage || err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		changePackagingDelete(item) {
			let url = 'orders/updatepackaging';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);
			axios
				.post(`${this.getUrl}${url}`, { item: payload, Packaging: {} }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					item.Packaging = {};
				})
				.catch(err => {
					if (err.response) {
						const apiMessage = err.response?.data?.message;
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = apiMessage || err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		/**
		 * Assegna il tag a un ordine.
		 * `value` e' una stringa colore quando il profilo non ha tag configurati (comportamento
		 * storico), l'oggetto tag di `Profile.order_tags` quando li ha, `null` per rimuoverlo.
		 */
		changeStatus(item, value) {
			let url = 'orders/updatestatus';
			let payload = item;
			const tag = this.hasOrderTags ? (value ? { _id: value._id, label: value.label, color: value.color } : null) : undefined;
			const color = this.hasOrderTags ? (value ? value.color : null) : value;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);
			const body = { item: payload, color: color };
			if (this.hasOrderTags) {
				body.tag = tag;
			}
			axios
				.post(`${this.getUrl}${url}`, body, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					if (this.hasOrderTags) {
						// `Tag` puo' non esistere sull'ordine (mai taggato): serve $set, altrimenti
						// la chip non si aggiorna finche' non si ricarica la lista
						this.$set(this.getOrders[this.editIndex], 'Tag', tag);
						this.$set(this.getOrders[this.editIndex], 'Color', color);
					} else {
						Object.assign(this.getOrders[this.editIndex], { Color: color });
					}
				})
				.catch(err => {
					if (err.response) {
						const apiMessage = err.response?.data?.message;
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}
						this.snackbar.color = 'error';
						this.snackbar.text = apiMessage || err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selectedchecbox = [];
			} else {
				if (event[0] !== -1) {
					this.selectedchecbox = [];
					_.forEach(this.getOrders, cat => {
						this.selectedchecbox.push(cat._id);
					});
				}
			}
		},
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},
		copy(field) {
			let input = document.createElement('input');
			input.setAttribute('value', field);
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
		},
		scorporoiva(totale, iva) {
			let sc = 0;
			if (!iva || iva === 0) {
				iva = 22;
				iva = iva / 100;
				iva += 1;

				sc = parseFloat(totale / iva).toFixed(2);
			} else {
				sc = totale;
			}
			return sc;
		},
		cleardate() {
			this.parseDate = [];
			this.settings.filters.created_at = [];
		},
		cleardatePrep() {
			this.parseDate = [];
			this.settings.filters.preparation_date = [];
		},
		async importItemFromShopify() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'ImportShopify';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		async importItemsFromShopify() {
			this.componentKey += 1;
			this.setClearError({});
			this.operation = 'ImportsShopify';

			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},
		// riga passata dal menu della riga, oppure l'unico ordine selezionato nella barra
		orderIdFrom(key) {
			if (key && key._id) return key._id;
			return this.selectedchecbox[0] || null;
		},
		editItem(key) {
			const id = this.orderIdFrom(key);
			if (id) this.$router.push(`/orders/${id}`);
		},
		async sendfeedback(item) {
			let url = 'orders/feedback';
			this.setPreload(true);

			axios
				.post(
					`${this.getUrl}${url}`,
					{
						item,
					},
					{ headers: { Authorization: `Bearer ${this.getToken}` } },
				)
				.then(() => {
					this.setPreload(false);
					this.getDataFromApi();
				})
				.catch(err => {
					this.setPreload(false);
					if (err.response) {
						const apiMessage = err.response?.data?.message;
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = apiMessage || err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		summaryItem(key) {
			const id = this.orderIdFrom(key);
			if (id) this.$router.push(`/orders/${id}/summary`);
		},
		packingListItem(item) {
			// la packing list si apre come pagina; Indietro torna qui
			const pl = item && item.id_packing_list && item.id_packing_list[0];
			if (pl) openWithReturn(this, { path: `/packing-list/${pl._id}` }, { label: 'Torna agli ordini' });
		},
		trackingItem(key) {
			const id = this.orderIdFrom(key);
			if (id) this.$router.push(`/orders/${id}/tracking`);
		},
		async getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		duplicateItem(key) {
			const id = this.orderIdFrom(key);
			if (id) this.$router.push(`/orders/${id}/duplicate`);
		},

		toggleClass(num) {
			if (num === 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},
		resetForm() {
			this.form._id = '';
			this.form.name = '';
			this.form.email = '';
			this.form.password = '';
			this.form.action = '';
		},

		searchit: _.debounce(function () {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		}, 1000),

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;
				//const { sortBy, sortDesc, page, itemsPerPage } = this.settings.options;
				this.settings.filters.enableAgents = false;

				let items = this.fetchOrders(this.settings);
				items.then(result => {
					this.total = result?.total ?? 0;
					//this.items = result.data.data
					this.setPreload(false);
					this.selectedchecbox = [];
					this.selectedall = [];
				});
				/*let reports =  this.fetchReports(this.settings).then(result =>{
                        //console.log(result.data.data)
                        if(result.data.data) {
                            this.Totale = result.data.data.total;
                            this.Fee = result.data.data.TotalFee;
                            this.Refund = result.data.data.refund;
                            this.Gain = result.data.data.gain;
                        }


                    });*/
			} catch (err) {
				console.log(err);
			}
		},
		openNew() {
			this.$router.push('/orders/new');
		},

		printOrderMultiple() {
			let url = 'orders/print-multiple';
			this.preload = true;

			axios
				.post(
					`${this.getUrl}${url}`,
					{
						_ids: this.orders_to_print,
						worker: this.user_selected,
						preview_courier: this.courier_selected,
						printed: true,
						status: this.status_elaboration,
					},
					{ headers: { Authorization: `Bearer ${this.getToken}` } },
				)
				.then(() => {
					this.preload = false;
					this.dialogPrintMultiple = false;
					let split = this.orders_to_print.split(',');
					for (let o of this.getOrders) {
						if (split.includes(o._id)) {
							o.worker = this.user_selected;
							o.preview_courier = this.courier_selected;
							o.printed = true;
							o.StatusOrder = this.status_elaboration;
						}
					}

					let route = this.$router.resolve({ path: '/orders/multiple-print/' + this.orders_to_print });
					window.open(route.href, '_blank');
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		openReceipt(item) {
			let route = this.$router.resolve({ path: '/orders/receipt/' + item._id });
			window.open(route.href, '_blank');
		},

		printOrder() {
			let url = 'orders/update-details';
			this.preload = true;

			axios
				.post(
					`${this.getUrl}${url}`,
					{
						_id: this.order_to_print._id,
						worker: this.user_selected,
						preview_courier: this.courier_selected,
						printed: true,
						status: this.status_elaboration,
					},
					{ headers: { Authorization: `Bearer ${this.getToken}` } },
				)
				.then(() => {
					this.preload = false;

					this.dialogPrint = false;
					this.order_to_print.worker = this.user_selected;
					this.order_to_print.preview_courier = this.courier_selected;
					this.order_to_print.printed = true;
					this.order_to_print.StatusOrder = this.status_elaboration;

					let route = this.$router.resolve({ path: '/orders/print/' + this.order_to_print._id });
					window.open(route.href, '_blank');
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},

		openDialogPrint(item) {
			this.dialogPrint = true;
			this.order_to_print = item;
			this.courier_selected = item.preview_courier ? item.preview_courier : null;
			this.user_selected = item.worker ? item.worker : null;
		},
		printMultiple() {
			let orders_filtered = _.filter(this.getOrders, o => {
				if (this.selectedchecbox.includes(o._id)) {
					return o._id;
				}
			});
			let orders = [];
			for (let order of orders_filtered) {
				orders.push(order._id);
			}
			this.dialogPrintMultiple = true;
			this.orders_to_print = orders.toString();
			this.courier_selected = null;
			this.user_selected = null;
		},

		extension(item) {
			let prova = this.selected.includes(item);
			if (!prova) {
				this.selected.push(item);
			} else {
				let indice = this.selected.indexOf(item);
				this.selected.splice(indice, 1);
			}
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		getProductImage(prod, order) {
			const placeholder = require('@/assets/images/picture.svg');
			// immagine salvata sulla riga al momento dell'acquisto (robusta se il prodotto è stato eliminato)
			const snapshot = prod.image || null;
			const entry = (order.itemsImages || []).find(
				it => it._id?.toString() === prod.ProductId?.toString()
			);
			if (!entry || !entry.images || !entry.images.length) return snapshot || placeholder;
			// variante esatta venduta, se ha immagine dedicata
			if (prod.CatalogId) {
				const cat = prod.CatalogId.toString();
				const variantImg = entry.images.find(img =>
					(img.variants || []).some(v => v?.toString() === cat)
				);
				if (variantImg?.sizes?.[0]?.value) return variantImg.sizes[0].value;
			}
			// fallback: immagine principale del prodotto, poi snapshot, poi placeholder
			return entry.images[0]?.sizes?.[0]?.value || snapshot || placeholder;
		},

		async downloadReviewById() {
			this.errorDownloadReview = '';
			this.loadingDownload = true;
			var result = await this.getOrdersReview({ id_start: this.idStart, id_end: this.idEnd });
			this.loadingDownload = false;

			if (_.size(result.orders) > 0) {
				var textToSave = `RIEPILOGO ORDINI \n\n-------------------------\n`;

				_.forEach(result.orders, order => {
					textToSave += `\nOrdine Id: ${order.OrderID} - Data: ${new Date(order.created_at).toLocaleString()}\n`;
					textToSave += `\n${order.ShippingAddress.Name}\n\n`;

					textToSave += `Prodotti\n`;

					let sku_to_remove = [];

					for (let item of order.Items) {
						if (item.ItemID === 'Virtual') {
							let split_sku = item.SKU.split('-');
							if (split_sku.length > 1) {
								sku_to_remove.push(split_sku[0]);
							}
						}
					}

					if (sku_to_remove.length > 0) {
						order.Items = order.Items.filter(el => {
							return !sku_to_remove.includes(el.SKU);
						});
					}

					for (let item of order.Items) {
						// var name = item.Title.replace(/ *\([^)]*\) */g, "")
						var name = item.Title;
						var split = name.split('-');

						var final;
						if (split.length > 1) {
							var text_1 = split[0].replace(/ *\([^)]*\) */g, '');
							var text_2 = split[1].replace(/ *\([^)]*\) */g, '');
							var replace = text_2.replace(text_1, '');

							final = text_1;
							final += replace == '' || replace == ' ' ? '' : ' -' + replace;
						} else {
							final = name;
						}

						/*
            if(item.kits && item.kits.length > 0){

              textToSave += `-- ${item.Title} - Qtà: ${item.QuantityPurchased}\n`
              _.forEach(item.kits, (kit) =>{
                textToSave += `- ${kit.name} - Qtà: ${kit.qt}\n`
              })

            }else{

             */
						// textToSave += `${item.Title} - Qtà: ${item.QuantityPurchased}\n`
						textToSave += `${final} - Qtà: ${item.QuantityPurchased}\n`;
						//}

						if (_.toString(item.ItemID) == 'Virtual') {
							for (let kit_prod of item.kits) {
								textToSave += `${kit_prod.name}\n`;
							}
						}
					}

					textToSave += `\nMet. Pagamento: ${this.getPayment(order.Checkout.PaymentMethods)} \n`;
					textToSave += `Scatola: ${this.getPackage(order.Packaging)} \n\n`;

					if (order.ShippingService && order.ShippingService.ShippingService.toLowerCase().includes('express')) {
						textToSave += `* Spedizione Express \n\n`;
					}
					if (order.Message) {
						textToSave += `** Sono presenti note nell'ordine \n\n`;
					}
					//textToSave += `Scatola: ${this.getPackageFromColor(order.Color)} \n\n`
					//textToSave += `Corriere: ${(item.package) ? item.package : 'n.d.'} \n\n`

					textToSave += `-------------------------\n`;
				});

				var hiddenElement = document.createElement('a');

				var today = new Date();
				var h = today.getHours();
				var m = today.getMinutes();
				var s = today.getSeconds();

				var now = h + '_' + m + '_' + s;

				hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
				hiddenElement.target = '_blank';
				hiddenElement.download = now + '_riepilogo-ordini.txt';
				hiddenElement.click();
			} else {
				this.errorDownloadReview = 'Gli Id Ordini indicati non risultano corretti per individuare un range';
			}
		},

		async downloadReview() {
			let orders = _.filter(this.getOrders, o => {
				return this.selectedchecbox.includes(o._id);
			});

			if (_.size(orders) > 0) {
				let textToSave = `RIEPILOGO ORDINI \n\n-------------------------\n`;

				_.forEach(orders, order => {
					textToSave += `\nOrdine Id: ${order.OrderID} - Data: ${new Date(order.created_at).toLocaleString()}\n`;
					textToSave += `\n${order.ShippingAddress.Name}\n\n`;

					textToSave += `Prodotti\n`;
					_.forEach(order.Items, item => {
						/*
                    if(item.kits && item.kits.length > 0){

                      textToSave += `-- ${item.Title} - Qtà: ${item.QuantityPurchased}\n`
                      _.forEach(item.kits, (kit) =>{
                        textToSave += `- ${kit.name} - Qtà: ${kit.qt}\n`
                      })

                    }else{

                     */
						textToSave += `${item.Title} - Qtà: ${item.QuantityPurchased}\n`;
						//}
					});
					textToSave += `\nMet. Pagamento: ${this.getPayment(order.Checkout.PaymentMethods)} \n`;
					textToSave += `Scatola: ${this.getPackage(order.Packaging)} \n\n`;
					//textToSave += `Scatola: ${this.getPackageFromColor(order.Color)} \n\n`
					//textToSave += `Corriere: ${(item.package) ? item.package : 'n.d.'} \n\n`

					textToSave += `-------------------------\n`;
				});

				let hiddenElement = document.createElement('a');

				let today = new Date();
				let h = today.getHours();
				let m = today.getMinutes();
				let s = today.getSeconds();

				let now = h + '_' + m + '_' + s;

				hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
				hiddenElement.target = '_blank';
				hiddenElement.download = now + '_riepilogo-ordini.txt';
				hiddenElement.click();
			}
		},
		eliminaFattura(key) {
			let item;
			if (!key) {
				let el = this.selectedchecbox[0];
				item = _.find(this.getOrders, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}
			let url = 'fattureincloud/eliminaFattura';
			let payload = item;
			this.preload = true;
			this.editIndex = this.getOrders.indexOf(item);

			//console.log(`${this.getUrl}${url}`);
			axios
				.post(`${this.getUrl}${url}`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } })
				.then(({ data }) => {
					//   this.dialog = false;
					//   this.success = true;
					//	console.log(data.data);

					this.preload = false;
					this.snackbar.snackbar = true;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';

					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
					Object.assign(this.getOrders[this.editIndex], data.data);
					this.InvoiceItem = false;
					this.TypeInvoice = '';
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.snackbar = true;
						this.snackbar.color = 'error';
						this.snackbar.text = err.message;

						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		async annullaOrdineFornitore(key) {
			let items;
			if (key) {
				items = [key];
			} else {
				items = this.selectedchecbox
					.map(id => _.find(this.getOrders, i => i._id === id))
					.filter(i => i && i.preparation_date);
			}

			if (!items.length) return;

			this.preload = true;
			const url = 'orders-suppliers/rollback';

			const results = await Promise.allSettled(
				items.map(item =>
					axios.post(`${this.getUrl}${url}`, { order_id: item.OrderID.toString() }, { headers: { Authorization: `Bearer ${this.getToken}` } })
				)
			);

			this.preload = false;
			const failed = results.filter(r => r.status === 'rejected');

			if (failed.length === 0) {
				this.snackbar.snackbar = true;
				this.snackbar.color = 'success';
				this.snackbar.text = items.length > 1 ? `${items.length} ordini fornitore annullati` : 'Operazione effettuata con successo';
			} else {
				this.snackbar.snackbar = true;
				this.snackbar.color = failed.length === results.length ? 'error' : 'warning';
				this.snackbar.text = `${results.length - failed.length} annullati, ${failed.length} falliti`;
			}

			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			this.getDataFromApi();
			this.InvoiceItem = false;
			this.TypeInvoice = '';

			if (failed.length > 0) {
				let firstErr = failed[0].reason;
				if (firstErr?.response?.status === 401) {
					this.setLogout();
					this.$router.push('/login');
				}
			}
		},
		contactWhatsapp(number, order) {
			let message = `Salve la contatto per l'ordine #${order}`;
			let url = `https://api.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(message)}`;
			window.open(url, '_blank');
		},
		getImagePayment(img) {
			if (!img) {
				return require(`@/assets/images/Other.svg`);
			}

			try {
				return require(`@/assets/images/${img.value}.svg`);
			} catch (e) {
				return require(`@/assets/images/Other.svg`);
			}
		},
		getImageShip(item) {
			if (item.ShippedTime) {
				return require(`@/assets/images/box_ship.svg`);
			}
			if (item.CancelTime) {
				return require(`@/assets/images/box_cancel.svg`);
			}
			let delivery;
			item.Items.forEach(value => {
				delivery = value.Delivery_max;
			});

			if (delivery) {
				let fromDate = parseInt(new Date().getTime() / 1000);
				let toDate = parseInt(new Date(delivery).getTime() / 1000);
				let timeDiff = (toDate - fromDate) / 3600; // will give difference in hrs
				let box = '';

				if (timeDiff > 6) {
					return require(`@/assets/images/box.svg`);
				}
				if (timeDiff > 1 && timeDiff <= 6) {
					return require(`@/assets/images/box_warning.svg`);
				}
				if (timeDiff <= 1) {
					return require(`@/assets/images/box_late.svg`);
				}
				return require(box);
			} else {
				return require(`@/assets/images/box.svg`);
			}
		},

		getImageMarketplace(img) {
			let logo = '';
			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				case 'Cassa':
					logo = require(`@/assets/images/cassa.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		closeSnackbar() {
			this.setSnackbar(false);
		},
		// async confirm() {
		// 	let payload = this.form;
		// 	try {
		// 		this.preload = true;
		// 		await this.fetchUsers(payload);
		// 	} catch (err) {
		// 		console.log(err);
		// 	}
		// 	this.preload = false;
		// },

		getPackage(Packaging) {
			if (Packaging !== undefined) {
				return Packaging.name;
			} else {
				return 'n.d.';
			}
		},
		getPackageFromColor(color) {
			switch (color) {
				case 'grey':
					return 'n.d.';
				case 'red':
					return 1;
				case 'pink':
					return 2;
				case 'purple':
					return 3;
				case 'indigo':
					return 4;
				case 'blue':
					return 5;
				case 'green':
					return 6;
				case undefined:
					return 'n.d.';
				default:
					return 'n.d.';
			}
		},
		getPayment(payment) {
			switch (payment) {
				case 'american express':
				case 'creditcard':
				case 'maestro':
				case 'mastercard':
				case 'paypal':
				case 'visa':
					return 'Pagato';
				case 'bonifico bancario':
					return 'Bonifico';
				case 'cash on delivery (cod)':
				case 'cash on delivery cod':
				case 'cod':
					return 'Contrassegno';
				default:
					return payment;
			}
		},
		getStatusColor(statusId, prep_date) {
			// Fix Madò, in caso di ordine con data preparazione considera come in elaborazione
			if (prep_date !== null && (this.getId === '636f52667160ac8bc2d6df78' || this.getId === '60b2554c7aee6b735869408c')) {
				statusId._id = '60deb7436fee57191fa71150';
			}
			if (statusId && statusId._id) {
				let status = _.find(this.status, { value: statusId._id });
				return status ? status.color : '#FFFFFF';
			} else {
				return '#FFFFFF';
			}
		},
		formatPhoneNumber(phoneNumberString) {
			let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
			let match = cleaned.match(/^(39|)?(\d{3})(\d{3})(\d{4})$/);
			if (match) {
				let intlCode = match[1] ? '+39' : '+39';
				return [intlCode, match[2], match[3], match[4]].join('');
			} else {
				return null;
			}
		},
		confirmDelete(key) {
			let itemsToDelete = [];
			if (!key) {
				if (!this.selectedchecbox || this.selectedchecbox.length === 0) return;

				itemsToDelete = this.getOrders.filter(order => this.selectedchecbox.includes(order._id));
			} else {
				itemsToDelete = [key];
			}
			this.orderIdsToDelete = itemsToDelete.map(item => item._id);
			this.dialogconfirm = true;
		},

		deleteOrderConfirmed() {
			this.preload = true;
			const url = `${this.getUrl}orders`;

			axios
				.delete(url, {
					data: { ids: this.orderIdsToDelete },
					headers: { Authorization: `Bearer ${this.getToken}` },
				})
				.then(({ data }) => {
					this.snackbar = {
						snackbar: true,
						color: 'success',
						text: `Ordine/i eliminato/i con successo (${data.deletedCount})`,
						mode: 'multi-line',
						timeout: 5000,
					};
					this.getDataFromApi();
				})
				.catch(err => {
					const msg = err.response?.data?.message || err.message || 'Errore generico';
					this.snackbar = {
						snackbar: true,
						color: 'error',
						text: msg,
						mode: 'multi-line',
						timeout: 5000,
					};
					if (err.response?.status === 401) {
						this.setLogout();
						this.$router.push('/login');
					}
				})
				.finally(() => {
					this.preload = false;
					this.dialogconfirm = false;
					this.orderIdsToDelete = [];
				});
		},
		isDarkColor(hex) {
			return isDarkColor(hex);
		},
		// chip del tag ordine: sfondo del tag, testo bianco su colore scuro e nero su chiaro
		tagChipStyle(tag) {
			return {
				backgroundColor: tag.color,
				color: isDarkColor(tag.color) ? '#FFFFFF' : '#000000',
				cursor: 'pointer',
			};
		},
	},
	beforeDestroy() {
		this.$root.$off('updateOrdersList', this.onUpdateOrdersList);
		this.tour.stop();
		this.destroyData();
	},
};
</script>

<style scoped>
.v-tooltip__content {
	position: absolute !important;
}
.text-white {
	color: #ececec !important;
}
.order-cell {
	min-width: 220px;
	padding-top: 6px !important;
	padding-bottom: 6px !important;
	line-height: 1.35;
}
.order-id-cell {
	white-space: nowrap;
	line-height: 1.35;
}
.order-id,
.order-buyer {
	font-weight: 600;
}
/* Opacita' e non grigio fisso: sulle righe con colore scuro il testo e' bianco */
.order-label {
	font-size: 0.7rem;
	text-transform: uppercase;
	opacity: 0.65;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.order-cards,
.order-cards tr {
	display: block;
	width: 100%;
}
.order-cards tr,
.order-cards tr:hover {
	background: transparent !important;
}
.order-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.order-cards tr:first-child td {
	padding-top: 12px !important;
}
.order-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.order-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
/* dettaglio ordine dentro la card (il "+") */
.order-section {
	font-size: 0.75rem;
	font-weight: 700;
	text-transform: uppercase;
	color: rgba(0, 0, 0, 0.6);
	margin-bottom: 4px;
}
.order-line {
	background: #f7f8fa;
	border-radius: 6px;
	padding: 8px 10px;
	font-size: 14px;
	word-break: break-word;
}
.order-line + .order-line {
	margin-top: 6px;
}
.order-kv {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px;
	color: rgba(0, 0, 0, 0.6);
}
.order-kv-v {
	color: rgba(0, 0, 0, 0.87);
	text-align: right;
	word-break: break-word;
}
</style>
